import { Field } from 'formik'
import React, { ReactNode, useCallback } from 'react'
import { useIntl } from 'react-intl'
import { SelectField } from '../../field'
import { useSettings } from '../../../../../containers/Parameters'

interface Props {
  name: string
  label?: string
  onChange?: (arg?: string | number) => void
  required?: boolean
  clearable?: boolean
  searchable?: boolean
  placeholder?: string
  children?: ReactNode
  disabled?: boolean
}

export const OperatorInput: React.FC<Props> = ({
  clearable,
  name,
  label,
  onChange,
  placeholder,
  required,
  searchable,
  disabled = false,
}) => {
  const intl = useIntl()
  const validate = useCallback(
    (value: string | null): string | undefined => {
      if (required && (!value || !value.trim())) {
        return intl.formatMessage({ id: 'validation.requiredField' })
      }
      return undefined
    },
    [required, intl]
  )

  const settings = useSettings()

  if (!settings) {
    return null
  }

  return (
    <Field
      disabled={disabled}
      clearable={clearable}
      component={SelectField}
      id={name}
      name={name}
      label={label}
      required={required}
      validate={validate}
      onChange={onChange}
      searchable={searchable}
      placeholder={placeholder}
      options={settings.operators.map(operator => ({
        label: operator.name,
        value: operator.id,
      }))}
    />
  )
}
